export function isEmailValid(email: string) {
  const emailValidation =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return emailValidation.test(email)
}

export function isPhoneNumberValid(phone: string) {
  const phoneValidation = /^0[0-8]\d{8}$/
  return phoneValidation.test(phone)
}

export function getEmailError(email: string) {
  let error: string | false = false
  error = !isEmailValid(email) ? 'Please enter a valid email address' : false
  return error
}

export function getMobileError(mobile: string) {
  let error: string | false = false
  error = !isPhoneNumberValid(mobile) ? 'Please enter a valid Australian mobile number' : false
  return error
}

export function getPhoneError(phone: string) {
  let error: string | false = false
  error =
    phone.length > 0 && !isPhoneNumberValid(phone)
      ? 'Please enter a valid Australian phone number'
      : false
  return error
}
